export const ADMIN_LOGIN_REQUEST = "ADMIN_LOGIN_REQUEST";
export const ADMIN_LOGIN_FAIL = "ADMIN_LOGIN_FAIL";
export const ADMIN_LOGIN_SUCCESS = "ADMIN_LOGIN_SUCCESS";
export const ADMIN_LOGOUT = "ADMIN_LOGOUT";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const USER_VIEW_REQUEST = "USER_VIEW_REQUEST";
export const USER_VIEW_FAIL = "USER_VIEW_FAIL";
export const USER_VIEW_SUCCESS = "USER_VIEW_SUCCESS";

export const VIEW_ACCREDITED_INVESTORS = "VIEW_ACCREDITED_INVESTORS";
export const VIEW_ACCREDITED_INVESTORS_FAIL = "VIEW_ACCREDITED_INVESTORS_FAIL";
export const VIEW_ACCREDITED_INVESTORS_SUCCESS =
  "VIEW_ACCREDITED_INVESTORS_SUCCESS";

export const VIEW_COUNTRY_DETAILS = "VIEW_COUNTRY_DETAILS";
export const VIEW_COUNTRY_DETAILS_FAIL = "VIEW_COUNTRY_DETAILS_FAIL";
export const VIEW_COUNTRY_DETAILS_SUCCESS = "VIEW_COUNTRY_DETAILS_SUCCESS";

export const SAVE_CURRENCY_DETAILS = "SAVE_CURRENCY_DETAILS";
export const SAVE_CURRENCY_DETAILS_FAIL = "SAVE_CURRENCY_DETAILS_FAIL";
export const SAVE_CURRENCY_DETAILS_SUCCESS = "SAVE_CURRENCY_DETAILS_SUCCESS";

export const USER_VIEW_INVESTMENT_REQUEST = "USER_VIEW_INVESTMENT_REQUEST";
export const USER_VIEW_INVESTMENT_FAIL = "USER_VIEW_INVESTMENT_FAIL";
export const USER_VIEW_INVESTMENT_SUCCESS = "USER_VIEW_INVESTMENT_SUCCESS";

export const VIEW_FOLLOWER_REPORT_SUCCESS = "VIEW_FOLLOWER_REPORT_SUCCESS";
export const VIEW_FOLLOWER_REPORT_REQUEST = "VIEW_FOLLOWER_REPORT_REQUEST";
export const VIEW_FOLLOWER_REPORT_FAIL = "VIEW_FOLLOWER_REPORT_FAIL";
